import { Fragment, useEffect, useMemo, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Header from "../../component/Header";
import Pagination from "../../component/Pagination";
import DiamondsFour from "../../component/SvgIcons/DiamondsFour";
import IconDate from "../../component/SvgIcons/IconDate";
import IconFilter from "../../component/SvgIcons/IconFilter";
import IconSearchTable from "../../component/SvgIcons/IconSearchTable";
import DateFilter from "../../component/DateFilter/DateFilter";
import api from "../../services/axios";
import useBootstrapTooltip from "../../services/useBootstrapTooltip";
import AudioPlayer from "../TicketsDetails/AudioPlayer";
import { useAuth } from "../../context/AuthContext";
import { AnimatePresence, motion, useResetProjection } from "framer-motion";
import CustomDropdown from "../../component/CustomDropdown";
import numberOptions from "../../component/NumberOptions/numberOptionsdata";
import { Sidebar } from "primereact/sidebar";
import { Button } from "primereact/button";
import "./style.css";
import utils from "../../utils/utils";

export default function CallRecords() {
  const selectAllRef = useRef();
  const [visibleRight, setVisibleRight] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [isCustomDateFilter, setIsCustomDateFilter] = useState(false);
  const [filteredCalls, setFilteredCalls] = useState([]);
  const [rowData, setRowData] = useState([]);
  const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });
  const [isLoading, setIsLoading] = useState(false);
  const [filters, setFilters] = useState({});
  const [itemsPerPage, setItemsPerPage] = useState(
    window.innerWidth >= 1920 ? 16 : 10
  );

  const getCallIcon = (call) => {
    if (call?.call_status.toLowerCase() === "answered") {
      return call?.direction.toLowerCase() === "outbound"
        ? "images/PhoneOutgoing.png"
        : "images/PhoneIncoming.png";
    } else {
      return call?.direction.toLowerCase() === "outbound"
        ? "images/PhoneOutgoing-missed.png"
        : "images/PhoneIncoming-missed.png";
    }
  };

  const { authUser } = useAuth();
  useEffect(() => {
    utils.saveRecentSearch("call List", "/call-records");
  }, []);
  useEffect(() => {
    const fetchCallRecords = async () => {
      setIsLoading(true);
      try {
        let payload = {};
        payload = {
          filterOptions: Object.keys(filters)?.length ? filters : { direction: 'inbound' }
        }
        const res = await api.post("/GetCallRecordings", payload);

        if (res.data.data && Array.isArray(res.data.data)) {
          setRowData(res.data.data);
          setFilteredCalls(res.data.data);
        } else {
          setRowData([]);
          setFilteredCalls([]);
          console.warn("Unexpected data format:", res.data.data);
        }
      } catch (error) {
        console.error("Failed to fetch tickets:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchCallRecords();
  }, [filters]);

  const handlePeriodSelect = (filterObj) => {
    console.log(filterObj)
    // setFilterDates([startDate, endDate]);
    setFilters(filterObj)
  };




  // ✅ Handle Sorting
  const handleSort = (column) => {
    setSortConfig((prevConfig) => {
      if (prevConfig.key === column) {
        return {
          ...prevConfig,
          direction: prevConfig.direction === "asc" ? "desc" : "asc",
        };
      } else {
        return {
          key: column,
          direction: "asc",
        };
      }
    });
  };
  // ✅ Handle Search
  const handleSearch = (e) => {
    setSearchQuery(e.target.value);
    setCurrentPage(1);
  };


  useEffect(() => {
    let response = rowData.filter((row) => {
      if (!row || typeof row !== 'object') return false;
      return Object.values(row).some((value) => {
        if (value == null) return false;
        return value.toString().toLowerCase().includes(searchQuery.toLowerCase());
      });
    })
      .sort((a, b) => {
        if (!sortConfig.key) return 0;
        const aValue = a[sortConfig.key];
        const bValue = b[sortConfig.key];
        if (aValue === undefined || bValue === undefined) return 0;
        const isNumber = !isNaN(aValue) && !isNaN(bValue);
        return isNumber
          ? (sortConfig.direction === 'asc' ? Number(aValue) - Number(bValue) : Number(bValue) - Number(aValue))
          : (sortConfig.direction === 'asc'
            ? String(aValue).localeCompare(String(bValue))
            : String(bValue).localeCompare(String(aValue)));
      });

    setFilteredCalls(response);
  }, [searchQuery, sortConfig, rowData])

  const totalPages = Math.ceil(filteredCalls.length / itemsPerPage);

  const paginatedData = filteredCalls.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );


  // ✅ Initialize Bootstrap tooltips
  useBootstrapTooltip([paginatedData, currentPage]);
  // ✅ Handle page change
  const handlePageChange = (page) => {
    console.log("Page clicked:", page);
    if (page < 1 || page > totalPages) return;
    setCurrentPage(page);
  };

  const formatDateTime = (dateString) => {
    const date = dateString.split('T')[0];
    // const date = new Date(dateString);
    // // Format: DD-MM-YYYY
    // const formattedDate = date.toLocaleDateString("en-GB").replaceAll("/", "-");
    // // Format: hh:mm AM/PM
    // const formattedTime = date.toLocaleTimeString("en-GB", {
    //   hour: "2-digit",
    //   minute: "2-digit",
    //   hour12: true,
    // });
    return `${date}`;
  };

  return (
    <div className="dashboard">
      <Header title subtitle="Call Records" searchbar />
      <div className="center-content">
        <div className="container">
          <div className="pagegap d-flex flex-column">
            <AnimatePresence mode="wait">
              <motion.div
                className="pagegap d-flex flex-column"
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: -10 }}
                transition={{ duration: 0.4 }}
              >
                <h2 className="create-titles mb-0 d-flex align-items-center">
                  <DiamondsFour /> <span>Call Records</span>
                </h2>
                <div className="tabletopbar d-flex align-items-center gap-2 justify-content-between flex-column flex-md-row">
                  <div className="d-flex align-items-center gap-3 justify-center" style={{ justifyContent: 'space-between', width: '100%', alignContent: 'center' }}>
                    <DateFilter showDateFilter={true} onPeriodSelect={handlePeriodSelect} />
                    <div style={{ display: 'flex' }}>
                      <div className="tablesearch position-relative">
                        <input
                          className="form-control"
                          type="text"
                          placeholder="Search"
                          value={searchQuery}
                          onChange={handleSearch}
                        />
                        <span className="position-absolute">
                          <IconSearchTable />
                        </span>
                      </div>

                      <CustomDropdown
                        name="itemsPerPage"
                        options={numberOptions}
                        value={itemsPerPage.toString()}
                        onChange={(value) => {
                          const num = Number(value);
                          setItemsPerPage(num);
                          setCurrentPage(1);
                        }}
                        placeholder="Items Per Page"
                        className="items-per-page-dropdown"
                      />
                    </div>
                  </div>
                </div>
                <div className="tablespace">
                  <div className="table-responsive">
                    <table className="table table-hover my-0">
                      <thead className="thead-light">
                        <tr>
                          <th width="50" style={{ paddingRight: "5px" }}>
                            Sr. No
                          </th>
                          <th width="70">
                            <div className="d-flex align-items-center justify-content-between" style={{ width: 40 }}>
                              Direction
                              <span
                                style={{ cursor: "pointer" }}
                                onClick={() => handleSort("direction")}
                              >
                                <IconFilter />
                              </span>
                            </div>
                          </th>
                          <th width="70">
                            <div className="d-flex align-items-center justify-content-between" style={{ width: 42 }}>
                              Call Status
                              <span
                                style={{ cursor: "pointer" }}
                                onClick={() => handleSort("call_status")}
                              >
                                <IconFilter />
                              </span>
                            </div>
                          </th>
                          <th width="100">
                            <div className="d-flex align-items-center">
                              <div className="d-flex align-items-center justify-content-between w-100">
                                <span>
                                  <IconDate /> Date & Time</span>
                                <span
                                  style={{ cursor: "pointer" }}
                                  onClick={() =>
                                    handleSort("start_stamp")
                                  }
                                >
                                  <IconFilter />
                                </span>
                              </div>
                            </div>
                          </th>
                          <th width="100">
                            <div className="d-flex align-items-center justify-content-between">
                              Agent Name
                              <span
                                style={{ cursor: "pointer" }}
                                onClick={() => handleSort("answered_agent_name")}
                              >
                                <IconFilter />
                              </span>
                            </div>
                          </th>
                          <th width="150">
                            <div className="d-flex align-items-center justify-content-between">
                              Agent Phone Number
                              <span
                                style={{ cursor: "pointer" }}
                                onClick={() => handleSort("answered_agent_number")}
                              >
                                <IconFilter />
                              </span>
                            </div>
                          </th>
                          <th width="100">
                            <div className="d-flex align-items-center justify-content-between">
                              Extension Number
                              <span
                                style={{ cursor: "pointer" }}
                                onClick={() => handleSort("call_to_number")}
                              >
                                <IconFilter />
                              </span>
                            </div>
                          </th>
                          <th width="100">
                            <div className="d-flex align-items-center justify-content-between">
                              Customer Number
                              <span
                                style={{ cursor: "pointer" }}
                                onClick={() => handleSort("caller_id_number")}
                              >
                                <IconFilter />
                              </span>
                            </div>
                          </th>

                          {authUser?.Agents_Company?.trim() === "Global Assist" && (
                            <th width="150">Recorded Call</th>
                          )}
                        </tr>
                      </thead>
                      <tbody>
                        {isLoading ? (
                          <tr>
                            <td colSpan="10" className="text-center" style={{ padding: "30px" }}>
                              Loading call recordings, please wait...
                            </td>
                          </tr>
                        ) : paginatedData?.length > 0 ? (
                          paginatedData?.map((latestItem, mainIndex) => {
                            const mainSerial = (currentPage - 1) * itemsPerPage + mainIndex + 1;
                            return (
                              <Fragment key={mainIndex}>
                                {/* Render the latest ticket row */}
                                <tr
                                  key={latestItem?.Call_Sr_No}
                                  className={[
                                    selectedRows.includes(latestItem?.Ticket_No) ? "ticket-row selected-row" : "ticket-row"
                                  ].join(" ")}
                                  style={{ cursor: "pointer" }}>
                                  <td className="text-center">
                                    <span>{mainSerial}</span>
                                  </td>
                                  <td data-bs-toggle="tooltip"
                                    data-bs-placement="top" title={latestItem?.direction == 'outbound' ? 'Outgoing Call' : 'Incoming Call'}
                                  >
                                    {latestItem?.direction == 'outbound' ? (<img style={{ width: '20px' }} src="images/ArrowUpRight.png" />) : (<img style={{ width: '20px' }} src="images/ArrowDownLeft.png" />)}
                                  </td>
                                  <td data-bs-toggle="tooltip"
                                    data-bs-placement="top" title={latestItem?.call_status}>
                                    <img style={{ width: "20px" }} src={getCallIcon(latestItem)} />
                                  </td>
                                  <td>
                                    <p className="colorblack mb-0">
                                      {formatDateTime(latestItem?.start_stamp)}
                                    </p>
                                  </td>
                                  <td data-bs-toggle="tooltip" data-bs-placement="top" title={latestItem?.answered_agent_name || ""}>
                                    {latestItem?.answered_agent_name ? (() => {
                                      const words = latestItem?.answered_agent_name.split(" ");
                                      return words.slice(0, 2).join(" ") + (words.length > 3 ? "..." : "");
                                    })() : "-"}
                                  </td>
                                  <td>
                                    {latestItem?.answered_agent_number || '-'}
                                  </td>
                                  <td>
                                    {latestItem?.call_to_number}
                                  </td>
                                  <td>
                                    {latestItem?.caller_id_number}
                                  </td>

                                  {authUser?.Agents_Company?.trim() === "Global Assist" && (
                                    <td onClick={(e) => { e.stopPropagation(); }}>
                                      <AudioPlayer url={latestItem?.recording_url} />
                                    </td>
                                  )}

                                </tr>
                              </Fragment>
                            );
                          })
                        ) : (
                          <tr>
                            <td colSpan="10" className="text-center">
                              No data found for the selected custom date range.
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                  {totalPages > 1 && (
                    <Pagination
                      totalPages={totalPages}
                      currentPage={currentPage}
                      handlePageChange={handlePageChange}
                    />
                  )}
                </div>
              </motion.div>
            </AnimatePresence>
          </div>
        </div>
      </div>
    </div>
  );
}
